import React, { FC, useRef } from "react";
import { defineMessages, useIntl } from "react-intl";
import { DateRange as RangeModifier } from "@natera/material/lib/date";
import DayRangePicker from "@app/components/dayRangePicker";
import { handleKeyDownByRef } from "@app/utils/handleKeyDown";

import "./dateRange.scss";

const messages = defineMessages({
  selectDateRange: {
    id: "selectDateRange",
    defaultMessage: "Select date range",
  },
});

interface Props {
  rangeDate: (date$: RangeModifier) => void;
  getHistory: (from?: Date, to?: Date, page?: number) => void;
  reset: () => void;
}

const DateRange: FC<Props> = ({ rangeDate, getHistory, reset }) => {
  const intl = useIntl();
  const [day, setDay] = React.useState<RangeModifier | undefined>(undefined);

  const divRef = useRef<HTMLDivElement | null>(null);

  const onSelectRange = (date$: RangeModifier) => {
    setDay(date$);
    rangeDate(date$);

    if (date$) {
      date$.from?.setHours(0, 0, 0, 0);
      date$.to?.setHours(23, 59, 59, 999);
      getHistory(date$.from, date$.to, 0);
    } else {
      reset();
      getHistory();
    }
  };

  return (
    <div
      ref={divRef}
      className="date-range"
      onKeyDown={handleKeyDownByRef(divRef)}
    >
      <DayRangePicker
        name="from"
        ariaLabel={intl.formatMessage(messages.selectDateRange)}
        value={
          day?.from && day.to
            ? `${day.from.toLocaleDateString(
                "en-US"
              )} - ${day.to.toLocaleDateString("en-US")}`
            : `${intl.formatMessage(messages.selectDateRange)}`
        }
        onSelectRange={onSelectRange}
      />
    </div>
  );
};

export default DateRange;
